import { defaultPlateCountry, formatPlate, plateCountry, plateGroups } from "@szerviz/core";
import { useApp } from "../context";

const STARS = Array.from({ length: 12 }, (_, i) => {
  const a = (i * Math.PI) / 6;
  return [10 + 7 * Math.sin(a), 10 - 7 * Math.cos(a)] as const;
});

/**
 * A licence plate drawn the European way: white plate, blue EU band with the
 * ring of stars and the country sign, the national mark between the groups.
 * The frame is exactly as long as the plate number. Country null = the
 * workshop's own country.
 */
export function Plate({ plate, country, size = "md" }: { plate: string; country?: string | null; size?: "sm" | "md" | "lg" }) {
  const { workshop } = useApp();
  const code = country ?? defaultPlateCountry(workshop.language);
  const c = plateCountry(code);
  const groups = plateGroups(plate, code);
  const style = c?.stripes ? { borderTopColor: c.stripes, borderBottomColor: c.stripes, borderTopWidth: "0.22em", borderBottomWidth: "0.22em" } : undefined;
  return (
    <span className={`eplate eplate-${size}`} style={style} role="img" aria-label={formatPlate(plate, code)} title={c ? `${c.sign} ${formatPlate(plate, code)}` : formatPlate(plate, code)}>
      {c && (
        <span className="eplate-band" style={c.band ? { background: `linear-gradient(${c.band[0]} 50%, ${c.band[1]} 50%)` } : undefined} aria-hidden="true">
          {c.eu && (
            <svg viewBox="0 0 20 20" className="eplate-stars">
              {STARS.map(([x, y], i) => (
                <circle key={i} cx={x} cy={y} r="1.15" fill="#ffcc00" />
              ))}
            </svg>
          )}
          <span className="eplate-sign">{c.sign}</span>
        </span>
      )}
      <span className="eplate-text">
        {groups[0]}
        {groups.length === 2 && (
          <>
            {c?.mark && (
              <span className="eplate-mark" style={{ background: `linear-gradient(${c.mark[0]} 33.3%, ${c.mark[1]} 33.3% 66.6%, ${c.mark[2]} 66.6%)` }} />
            )}
            {!c?.mark && " "}
            {groups[1]}
          </>
        )}
      </span>
    </span>
  );
}
